import { Route, Switch } from 'react-router-dom';

import InventoryControlForm from './pages/inventory-control/Form';
import InventoryControl from './pages/inventory-control/Home';
import Success from './pages/inventory-control/Success';
import Login from './pages/Login';
import OutletCrewForm from './pages/outlet-crew/Form';
import OutletCrew from './pages/outlet-crew/Home';
import OutletCrewSuccess from './pages/outlet-crew/Success';
import TechSupport from './pages/tech-support/Home';

const App = () => (
	<Switch>
		<Route exact path="/" component={Login} />
		<Route path="/outlet-crew" component={OutletCrew} />
		<Route path="/outlet-crew-form" component={OutletCrewForm} />
		<Route path="/outlet-crew-success" component={OutletCrewSuccess} />
		<Route exact path="/inventory-control" component={InventoryControl} />
		<Route path="/inventory-control/add" component={InventoryControlForm} />
		<Route path="/inventory-control/:id" component={InventoryControlForm} />
		<Route path="/success" component={Success} />
		<Route path="/tech-support" component={TechSupport} />
	</Switch>
);

export default App;
